<div class="c-home__header">
	<tvcore-ivv-title title="Ons aanbod"></tvcore-ivv-title>

	<div class="c-home__header__buttons">
		<a [href]="RRN_APP_URL" class="c-btn--with-icon" target="_blank">
			Sociale Organisatie: vakantieganger toevoegen
			<tvcore-icon name="external-link"></tvcore-icon>
		</a>

		<span class="show-on-1024">|</span>

		<a [routerLink]="['/', 'favorites']" class="c-favorites-btn">
			{{ 'HOME.FAVORITES' | translate }}
			<tvcore-icon name="heart"></tvcore-icon>

			@if (favorites$ | async; as amount) {
				<span>{{ amount }}</span>
			}
		</a>
	</div>
</div>

<a [routerLink]="backRoute" class="back-btn u-text--medium">
	<tvcore-icon name="arrow"></tvcore-icon>
	{{ 'DETAIL.BACK_BUTTON' | translate }}
</a>

@if (offer(); as offer) {
	<h1 class="u-title u-m-top--md">{{ offer.name }}</h1>

	<div class="flex-row flex-column--sm flex--space u-m-top--xxs">
		<div class="flex-row flex-column--sm">
			@if (offer.type !== OffersType.ORGANIZED_HOLIDAY) {
				<a [href]="'https://maps.google.com/maps?q=' + addressFull()" class="address-btn" target="_blank">
					<tvcore-icon name="location-pin-alt"></tvcore-icon>
					{{ addressFull() }}
				</a>

				<div class="tag">
					<tvcore-icon name="tag"></tvcore-icon>
					{{ 'PRODUCT_TYPE.' + offer.subtype | translate }}
				</div>
			}
		</div>

		<div class="flex-row flex-column--sm">
			<button (click)="showShareDialog.set(true)" class="c-btn-link share-btn u-m-right--sm">
				<tvcore-icon name="share"></tvcore-icon>
				{{ 'DETAIL.SHARE_BUTTON' | translate }}
			</button>

			<button (click)="toggleFavorite()" class="c-btn-link favorite-btn">
				@if (isFavorite()) {
					<tvcore-icon name="heart-filled"></tvcore-icon>
					{{ 'DETAIL.REMOVE_FROM_FAVORITES' | translate }}
				} @else {
					<tvcore-icon name="heart"></tvcore-icon>
					{{ 'DETAIL.ADD_TO_FAVORITES' | translate }}
				}
			</button>
		</div>
	</div>

	<ivva-images-header [offer]="offer"></ivva-images-header>

	<div class="c-intro">
		<div class="flex--1">
			<p class="u-title-sub u-m-bottom--xxs">{{ offer.promotitle }}</p>
			<p [innerHTML]="offer.promodescription"></p>
		</div>

		<div class="c-price-box">
			@if (pricingVisible()) {
				@switch (offer.type) {
					@case (OffersType.DAYTRIP) {
						@if (offer.price !== undefined) {
							<p [innerHTML]="formatPrice(offer.price)" class="u-title"></p>
							<p class="u-m-bottom--sm">
								{{ 'PRICE_DESCRIPTION.PER_ADULT' | translate }}
								<button (click)="showPriceInfo.set(true)" class="c-btn-link u-text--normal u-text--sm">Uitleg</button>
							</p>
						} @else {
							<p class="u-m-bottom--sm">Geen prijzen vermeld.</p>
						}
					}
					@case (OffersType.ACCOMMODATION) {
						@if (offer.pricePeakseason !== undefined) {
							<p class="u-title">
								<span [innerHTML]="formatPrice(offer.pricePeakseason)"></span>
								<span class="u-text--sm u-text--normal u-m-left--tiny">{{ 'PRICE_DESCRIPTION.IN_PEAK_SEASON' | translate }}</span>
							</p>
							<p class="u-m-bottom--sm">
								{{ 'PRICE_DESCRIPTION.' + (offer.accommodationPriceType ?? 'UNKNOWN') | translate }}
								<button (click)="showPriceInfo.set(true)" class="c-btn-link u-text--normal u-text--sm">Uitleg</button>
							</p>
						} @else {
							<p class="u-m-bottom--sm">Geen prijzen vermeld.</p>
						}
					}
				}
			} @else {
				@if (user()) {
					<p class="u-text--grey-blue u-m-bottom--sm">{{ 'DETAIL.NO_PRICING_ALLOWED' | translate }}</p>
				} @else {
					<p class="u-text--grey-blue u-m-bottom--sm">{{ 'DETAIL.NO_PRICING_VISIBLE' | translate }}</p>
				}
			}

			@if (offer.type === OffersType.ORGANIZED_HOLIDAY) {
				@if (offer.checkOfferUrl) {
					<p class="u-title-sub u-m-bottom--xs">Hoe boek je met korting?</p>

					<p class="u-m-bottom--tiny"><strong>Stap 1:</strong> Klik op de blauwe knop</p>
					<p class="u-m-bottom--tiny"><strong>Stap 2:</strong> Doe je boekingsaanvraag</p>
					<p class="u-m-bottom--tiny"><strong>Stap 3:</strong> Wacht op de bevestiging</p>

					<a [href]="offer.checkOfferUrl" class="c-btn-link c-btn--with-icon u-m-top--xs u-m-bottom--xs" style="justify-content: flex-start" target="_blank">
						Bekijk onze website voor extra info over de vakanties.
						<tvcore-icon name="external-link"></tvcore-icon>
					</a>

					@if (user()) {
						<a [routerLink]="['/', 'offers', id, 'booking']" class="c-btn c-btn--blue c-btn--unset">{{ 'DETAIL.OH_BOOKING.BOOKING_BUTTON' | translate }}</a>
					} @else {
						<button (click)="showSignInDialog.set(true)" class="c-btn c-btn--blue c-btn--unset">{{ 'DETAIL.NEEDS_SIGN_IN_BUTTON' | translate }}</button>
					}

					<p class="u-m-top--xs"><i>Alleen de vakanties in het aanvraagformulier zijn boekbaar via Iedereen Verdient Vakantie.</i></p>
				} @else {
					<ng-container [ngTemplateOutlet]="bookingButton"></ng-container>
				}
			} @else {
				<ng-container [ngTemplateOutlet]="bookingButton"></ng-container>
			}

			<ng-template #bookingButton>
				@if (user()) {
					<a [routerLink]="['/', 'offers', id, 'booking']" class="c-btn c-btn--blue c-btn--unset">{{ 'DETAIL.BOOKING_BUTTON' | translate }}</a>
				} @else {
					<button (click)="showSignInDialog.set(true)" class="c-btn c-btn--blue c-btn--unset">{{ 'DETAIL.NEEDS_SIGN_IN_BUTTON' | translate }}</button>
				}
			</ng-template>

			@if (pricingVisible() && offer.type === OffersType.ACCOMMODATION && offer.pricePeakseason !== undefined) {
				<hr class="u-m-top--sm u-m-bottom--sm" />

				<p class="u-title-group u-m-bottom--xxs">
					{{ 'PRICE_DESCRIPTION.PRICE_OFF_SEASON' | translate }}
					<tvcore-tooltip location="top">{{ 'PRICE_DESCRIPTION.PRICE_OFF_SEASON_INFO' | translate }}</tvcore-tooltip>
				</p>
				@if (priceBasedRentalUnit(); as unit) {
					<p class="u-text--medium u-m-bottom--tiny">{{ unit.name }}</p>
					<p class="u-m-bottom--tiny">{{ 'DETAIL.SINGLE_NIGHT' | translate }}</p>
					<p class="u-m-bottom--tiny">{{ 'MEAL_OPTION.' + offer.mealOffseason | translate }}</p>
				}
				<hr class="u-m-top--tiny u-m-bottom--tiny" />
				<div class="flex-row flex--space u-text--medium u-m-top--tiny u-m-bottom--tiny">
					<span>{{ 'PRICE_DESCRIPTION.TOTAL' | translate }}</span>
					<span [innerHTML]="formatPrice(offer.priceOffseason)"></span>
				</div>
				<p class="u-text--sm u-m-bottom--tiny">{{ 'DETAIL.EXCLUSIVE_TAXES' | translate }}</p>

				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">
					{{ 'PRICE_DESCRIPTION.PRICE_PEAK_SEASON' | translate }}
					<tvcore-tooltip location="top">{{ 'PRICE_DESCRIPTION.PRICE_PEAK_SEASON_INFO' | translate }}</tvcore-tooltip>
				</p>
				@if (priceBasedRentalUnit(); as unit) {
					<p class="u-text--medium u-m-bottom--tiny">{{ unit.name }}</p>
					<p class="u-m-bottom--tiny">{{ 'DETAIL.SINGLE_NIGHT' | translate }}</p>
					<p class="u-m-bottom--tiny">{{ 'MEAL_OPTION.' + offer.mealPeakseason | translate }}</p>
				}
				<hr class="u-m-top--tiny u-m-bottom--tiny" />
				<div class="flex-row flex--space u-text--medium u-m-top--tiny u-m-bottom--tiny">
					<span>{{ 'PRICE_DESCRIPTION.TOTAL' | translate }}</span>
					<span [innerHTML]="formatPrice(offer.pricePeakseason)"></span>
				</div>
				<p class="u-text--sm">{{ 'DETAIL.EXCLUSIVE_TAXES' | translate }}</p>
			}
		</div>
	</div>

	@if (offer.activities?.length) {
		<div class="c-activities">
			<p class="u-title-sub u-title-sub--line u-m-top--md">{{ 'DETAIL.ACTIVITIES' | translate }}</p>
			<ul>
				@for (activity of offer.activities; track activity.id) {
					<li>{{ activity.name }} <span [innerHTML]="formatPrice(activity.price)"></span></li>
				}
			</ul>
		</div>
	}

	@if (offer.rentalunits?.length) {
		<div class="c-rental-units-list">
			<p class="u-title-sub u-title-sub--line u-m-top--md u-m-bottom--sm">{{ 'DETAIL.RENTAL_UNITS_TITLE' | translate }}</p>

			@for (ru of offer.rentalunits; track ru.id) {
				<div class="c-rental-unit">
					<p class="u-text--medium u-m-bottom--xxs">{{ ru.name }}</p>
					<p class="u-m-bottom--tiny">
						<tvcore-icon name="tag"></tvcore-icon>
						@if (ru.type) {
							{{ 'RENTAL_UNIT_TYPE.' + ru.type | translate }}
						} @else {
							-
						}
					</p>
					<p>
						<tvcore-icon name="person"></tvcore-icon>
						{{ ru.numberOfPersons }} {{ 'DETAIL.PERSONS' | translate }}
					</p>
				</div>
			}
		</div>
	}

	@if (offer.type === OffersType.ORGANIZED_HOLIDAY) {
		@if (offer.niceToKnowDescription) {
			<div class="u-width--md">
				<p class="u-title-sub u-m-top--md u-m-bottom--xs">{{ 'DETAIL.NICE_TO_KNOW' | translate }}</p>
				<p [innerHTML]="offer.niceToKnowDescription" style="white-space: pre-line"></p>
			</div>
		}

		<div class="u-m-top--md">
			<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.TARGET_AUDIENCE' | translate }}</p>

			<p class="u-title-group u-m-bottom--xxs">{{ 'DETAIL.CAMPS' | translate }}</p>
			<ul class="c-list c-list--3">
				@for (ta of offer.targetAudiences; track ta) {
					<li>{{ 'TARGET_AUDIENCE.' + ta | translate }}</li>
				}
			</ul>

			@if (offer.exclusiveConditions?.length) {
				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.EXCLUSIVE_CAMPS' | translate }}</p>

				<div class="u-m-left--sm">
					@for (parent of offer.exclusiveConditions; track parent.id) {
						<p class="u-text--medium u-m-bottom--xxs">{{ parent.name }}</p>

						<ul class="c-list c-list--3 u-m-bottom--xs">
							@if (parent.conditions?.length) {
								@for (child of parent.conditions; track child.id) {
									<li>{{ child.name }}</li>
								}
							}
						</ul>
					}
				</div>
			}

			@if (offer.inclusiveConditions?.length) {
				<p class="u-title-group u-m-top--sm u-m-bottom--tiny">{{ 'DETAIL.INCLUSIVE_CAMPS' | translate }}</p>
				<p class="u-width--md u-m-bottom--xxs">{{ 'DETAIL.INCLUSIVE_CAMPS_INFO' | translate }}</p>

				<div class="u-m-left--sm">
					@for (parent of offer.inclusiveConditions; track parent.id) {
						<p class="u-text--medium u-m-bottom--xxs">{{ parent.name }}</p>

						<ul class="c-list c-list--3 u-m-bottom--xs">
							@if (parent.conditions?.length) {
								@for (child of parent.conditions; track child.id) {
									<li>{{ child.name }}</li>
								}
							}
						</ul>
					}
				</div>
			}
		</div>

		<div class="grey-container u-m-top--md">
			<p class="u-title-sub u-title-sub--line u-m-bottom--xxs">{{ 'DETAIL.THEMES' | translate }}</p>
			<p class="u-m-bottom--sm u-width--md">{{ 'DETAIL.THEMES_INFO' | translate }}</p>

			@for (parent of offer.themes; track parent.id) {
				<p class="u-title-group u-m-bottom--xs">{{ parent.name }}</p>

				<ul class="c-list c-list--3 u-m-bottom--sm">
					@if (parent.themes?.length) {
						@for (child of parent.themes; track child.id) {
							<li>{{ child.name }}</li>
						}
					}
				</ul>
			}
		</div>

		@if (offer.overnightPossible || offer.overnightNotPossible) {
			<div class="u-m-top--md">
				<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.OVERNIGHT' | translate }}</p>
				<ul class="c-list c-list--3">
					@if (offer.overnightPossible) {
						<li>{{ 'OVERNIGHT_STAY.WITH_OVERNIGHT_STAY' | translate }}</li>
					}

					@if (offer.overnightNotPossible) {
						<li>{{ 'OVERNIGHT_STAY.WITHOUT_OVERNIGHT_STAY' | translate }}</li>
					}
				</ul>
			</div>
		}

		@if (offer.destinations?.length) {
			<div class="u-m-top--md">
				<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.DESTINATION' | translate }}</p>
				<ul class="c-list c-list--3">
					@for (destination of offer.destinations; track destination) {
						<li>{{ 'DESTINATION.' + destination | translate }}</li>
					}
				</ul>
			</div>
		}

		@if (offer.periods?.length) {
			<div class="u-m-top--md">
				<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.PERIOD' | translate }}</p>
				<ul class="c-list c-list--3">
					@for (period of offer.periods; track period) {
						<li>{{ 'PERIOD.' + period | translate }}</li>
					}
				</ul>
			</div>
		}

		@if (offer.transportations?.length) {
			<div class="u-m-top--md">
				<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.TRANSPORT' | translate }}</p>
				<ul class="c-list c-list--3">
					@for (transport of offer.transportations; track transport) {
						<li>{{ 'TRANSPORTATION.' + transport | translate }}</li>
					}
				</ul>
			</div>
		}
	} @else {
		<div class="grey-container u-m-top--md">
			<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.PRACTICAL_INFO' | translate }}</p>

			@if (offer.meals?.length) {
				<p class="u-title-group u-m-bottom--xxs">{{ 'DETAIL.MEALS' | translate }}</p>
				<p [innerHTML]="offer.mealsDescription" class="u-width--md u-m-bottom--xxs"></p>

				<p class="u-m-bottom--xxs">{{ 'DETAIL.MEAL_DESCRIPTION' | translate }}</p>

				<ul class="c-check-list c-check-list--3 u-m-bottom--sm">
					@for (meal of offer.meals; track meal) {
						<li>
							<tvcore-icon name="checkmark"></tvcore-icon>
							{{ 'MEAL_OPTION.' + meal | translate }}
						</li>
					}
				</ul>
			}

			<p class="u-title-group u-m-bottom--xxs">{{ 'DETAIL.ACCESSIBILITY' | translate }}</p>
			<p [innerHTML]="offer.accessibilityDescription" class="u-width--md"></p>

			@if (offer.accessibilityLabel || offer.accessibilityGroups) {
				<ul class="c-check-list u-m-top--xxs">
					@if (offer.accessibilityLabel) {
						<li>
							<tvcore-icon name="checkmark"></tvcore-icon>
							{{ 'DETAIL.ACCESSIBILITY_LABEL_' + offer.accessibilityLabel | translate }}
						</li>
					}
					@if (offer.accessibilityGroups) {
						<li>
							<tvcore-icon name="checkmark"></tvcore-icon>
							{{ 'DETAIL.GROUPS_WELCOME' | translate }}
						</li>
					}
				</ul>
			}

			<p class="u-m-top--xxs">{{ 'DETAIL.SPECIFIC_NEEDS' | translate }}</p>

			@if (offer.type === OffersType.ACCOMMODATION) {
				@if (offer.minimumNumberOfNights > 1) {
					<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.NIGHTS_TITLE' | translate }}</p>
					<p class="u-width--md">{{ 'DETAIL.NIGHTS_DESCRIPTION' | translate: { nights: offer.minimumNumberOfNights } }}</p>
				}

				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.ANNULATION_TITLE' | translate }}</p>
				<p [innerHTML]="'DETAIL.ANNULATION_DESCRIPTION' | translate" class="u-width--md"></p>
			}

			@if (offer.facilities?.length) {
				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.FACILITIES' | translate }}</p>
				<ul class="c-check-list c-check-list--3">
					@for (facility of offer.facilities; track facility) {
						<li>
							<tvcore-icon name="checkmark"></tvcore-icon>
							{{ 'FACILITY.' + facility | translate }}
						</li>
					}
				</ul>
			}

			@if (offer.niceToKnowDescription) {
				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.EXTRA_INFO' | translate }}</p>
				<p [innerHTML]="offer.niceToKnowDescription"></p>
			}

			@if (offer.infoPriceDescription) {
				<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.PRICE_INFO' | translate }}</p>
				<p [innerHTML]="offer.infoPriceDescription"></p>
			}

			@if (offer.paymentOption || offer.extraPaymentInformation) {
				<div>
					<p class="u-title-group u-m-top--sm u-m-bottom--xxs">{{ 'DETAIL.PAYMENT' | translate }}</p>

					@if (offer.paymentOption) {
						<p>{{ 'PAYMENT_OPTION.' + offer.paymentOption | translate }}</p>
						<br />
					}

					@if (offer.extraPaymentInformation) {
						<p [innerHTML]="offer.extraPaymentInformation"></p>
					}
				</div>
			}

			@if (user()) {
				<a [routerLink]="['/', 'offers', id, 'booking']" class="c-btn c-btn--blue c-btn--lg u-m-top--sm">{{ 'DETAIL.BOOKING_BUTTON' | translate }}</a>
			} @else {
				<button (click)="showSignInDialog.set(true)" class="c-btn c-btn--blue c-btn--lg u-m-top--sm">{{ 'DETAIL.NEEDS_SIGN_IN_BUTTON' | translate }}</button>
			}
		</div>

		<div class="u-m-top--md">
			<p class="u-title-sub u-title-sub--line u-m-bottom--sm">{{ 'DETAIL.LOCATION' | translate }}</p>

			<p class="u-title-group u-m-bottom--xs">{{ 'DETAIL.ADDRESS' | translate }}</p>

			<p>{{ addressStreet() }}</p>
			<p>{{ addressCity() }}</p>

			<a [href]="'https://maps.google.com/maps?q=' + addressFull()" class="address-btn" target="_blank">
				{{ 'DETAIL.ROUTE_LINK' | translate }}
				<tvcore-icon name="external-link"></tvcore-icon>
			</a>
		</div>
	}

	<div class="c-contact-box u-m-top--md">
		<div class="u-row">
			<div class="flex--1">
				<p class="u-title-group u-m-bottom--tiny">{{ 'DETAIL.CONTACT' | translate }}</p>
				<p class="u-m-bottom--xs">{{ 'DETAIL.CONTACT_DESCRIPTION' | translate }}</p>

				@if (offer.website) {
					<p class="u-m-bottom--xxs">
						<tvcore-icon class="c-contact-icon" name="world"></tvcore-icon>
						<a [href]="convertWebsite(offer.website)" target="_blank">{{ convertWebsite(offer.website) }}</a>
					</p>
				}

				@if (offer.email) {
					<p class="u-m-bottom--xxs">
						<tvcore-icon class="c-contact-icon" name="mail"></tvcore-icon>
						<a [href]="'mailto:' + offer.email" target="_blank">{{ offer.email }}</a>
					</p>
				}

				@if (offer.phone) {
					<p class="u-m-bottom--xxs">
						<tvcore-icon class="c-contact-icon" name="phone"></tvcore-icon>
						<a [href]="'tel:' + offer.phone" target="_blank">{{ offer.phone }}</a>
					</p>
				}
			</div>

			@if (offer.reservationEmail || offer.reservationIndividualBookingEmail || offer.reservationGroupBookingEmail || offer.reservationTelephone) {
				<div class="flex--1">
					<p class="u-title-group u-m-bottom--tiny">{{ 'DETAIL.RESERVATION' | translate }}</p>
					<p class="u-m-bottom--xs">{{ 'DETAIL.RESERVATION_DESCRIPTION' | translate }}</p>

					@if (offer.reservationEmail) {
						<p class="u-m-bottom--xxs">
							<tvcore-icon class="c-contact-icon" name="mail"></tvcore-icon>
							<a [href]="'mailto:' + offer.reservationEmail" target="_blank">{{ offer.reservationEmail }}</a>
						</p>
					}

					@if (offer.reservationIndividualBookingEmail) {
						<p class="u-m-bottom--xxs">
							<tvcore-icon class="c-contact-icon" name="mail"></tvcore-icon>
							<a [href]="'mailto:' + offer.reservationIndividualBookingEmail" target="_blank">{{ offer.reservationIndividualBookingEmail }}</a>
							(individuele aanvragen)
						</p>
					}

					@if (offer.reservationGroupBookingEmail) {
						<p class="u-m-bottom--xxs">
							<tvcore-icon class="c-contact-icon" name="mail"></tvcore-icon>
							<a [href]="'mailto:' + offer.reservationGroupBookingEmail" target="_blank">{{ offer.reservationGroupBookingEmail }}</a>
							(groepsaanvragen)
						</p>
					}

					@if (offer.reservationTelephone) {
						<p class="u-m-bottom--xxs">
							<tvcore-icon class="c-contact-icon" name="phone"></tvcore-icon>
							<a [href]="'tel:' + offer.reservationTelephone" target="_blank">{{ offer.reservationTelephone }}</a>
						</p>
					}
				</div>
			}
		</div>

		@if (offer.facebook || offer.instagram) {
			<p>{{ 'DETAIL.SOCIALS' | translate }}</p>

			<div class="flex-row">
				@if (offer.facebook) {
					<a [href]="convertWebsite(offer.facebook)" class="c-social-icon" target="_blank">
						<tvcore-icon name="facebook"></tvcore-icon>
					</a>
				}

				@if (offer.instagram) {
					<a [href]="convertWebsite(offer.instagram)" class="c-social-icon" target="_blank">
						<tvcore-icon name="instagram"></tvcore-icon>
					</a>
				}
			</div>
		}
	</div>

	@if (nearbyOffers().length) {
		<p class="u-title-sub u-title-sub--line u-m-top--md u-m-bottom--sm">
			{{ (offer.type === OffersType.DAYTRIP ? 'DETAIL.SIMILAR_DAYTRIPS' : 'DETAIL.NEARBY_DAYTRIPS') | translate }}
		</p>

		@if (offer.type === OffersType.DAYTRIP) {
			<p class="u-m-bottom--sm">{{ 'DETAIL.SIMILAR_DAYTRIPS_DESCRIPTION' | translate }}</p>
		}

		<div class="c-nearby-offers">
			@for (no of nearbyOffers(); track no.id) {
				@if (no.id !== offer.id) {
					<ivva-offer-card [offer]="no"></ivva-offer-card>
				}
			}
		</div>
	}
} @else {
	<p class="u-m-top--md u-m-bottom--xlg">Bezig met laden. Even geduld aub...</p>
}

<ivva-newsletter></ivva-newsletter>

<tvcore-dialog (close)="showShareDialog.set(false)" [title]="'DETAIL.SHARE_DIALOG.TITLE' | translate" [visible]="showShareDialog()">
	<p class="u-m-bottom--xs">{{ 'DETAIL.SHARE_DIALOG.DESCRIPTION' | translate }}</p>
	<p class="u-text--medium u-m-bottom--tiny">{{ 'DETAIL.SHARE_DIALOG.LINK' | translate }}</p>

	<div class="link-box">
		<div id="linkaddress">{{ link }}</div>
		<button (click)="copyLink()" class="c-btn c-btn--sm c-btn--blue">{{ 'DETAIL.SHARE_DIALOG.COPY_BUTTON' | translate }}</button>
	</div>
</tvcore-dialog>

<tvcore-dialog (close)="showSignInDialog.set(false)" [title]="'DETAIL.SIGN_IN_DIALOG.TITLE' | translate" [visible]="showSignInDialog()">
	<div [innerHTML]="'DETAIL.SIGN_IN_DIALOG.CONTENT' | translate"></div>
	<button (click)="signIn()" class="c-btn c-btn--blue u-m-top--sm">{{ 'DETAIL.SIGN_IN_DIALOG.SIGN_IN_BUTTON' | translate }}</button>
</tvcore-dialog>

@if (offer()?.type === OffersType.ACCOMMODATION) {
	<tvcore-dialog (close)="showPriceInfo.set(false)" [title]="'PRICE_FILTER.ACCOMMODATION_DIALOG.TITLE' | translate" [visible]="showPriceInfo()">
		<div [innerHTML]="'PRICE_FILTER.ACCOMMODATION_DIALOG.CONTENT' | translate"></div>
		<hr class="u-m-top--sm u-m-bottom--sm" />
		<div [innerHTML]="'PRICE_FILTER.ACCOMMODATION_DIALOG.CONTENT_2' | translate"></div>
	</tvcore-dialog>
} @else if (offer()?.type === OffersType.DAYTRIP) {
	<tvcore-dialog (close)="showPriceInfo.set(false)" [title]="'PRICE_FILTER.DAYTRIP_DIALOG.TITLE' | translate" [visible]="showPriceInfo()">
		<div [innerHTML]="'PRICE_FILTER.DAYTRIP_DIALOG.CONTENT' | translate"></div>
	</tvcore-dialog>
}

<ivva-help></ivva-help>
